import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { BaseDialogComponent } from '../../../../kit/base-dialog/base-dialog.component';
import { fb, routeParams } from '../../../../../modules/shared/shared.global-service';
import { DateInputComponent } from '../../../../kit/input/date-input/date-input.component';
import { TranslatePipe } from '@ngx-translate/core';
import { CheckInputComponent } from '../../../../kit/input/check-input/check-input.component';
import { TextInputComponent } from '../../../../kit/input/text-input/text-input.component';
import { ActionButtonsComponent } from '../../../../kit/action-buttons/action-buttons.component';
import { FolderSickNotesHolInput } from '@libs/types/src/services/input-type/cssz/folder-sick-notes.hol-input';
import { AddressDetailObject } from '@it2go/types';
import { contentGlobalSuccess } from '../../../../../modules/content/content.error';
import { FolderSickNotesDoctorReportModalStore } from './folder-sick-notes-doctor-report-modal.store';
import { csszDateFormat, csszTimeFormat } from '../utils-CSSZ';
import { DiagnosisSelectInputComponent } from '../../../diagnosis-select-input/diagnosis-select-input.component';
import { AddressInputComponent } from '../../../../kit/input/address-input/address-input.component';

@Component({
    selector: 'app-folder-sick-notes-doctor-report-modal',
    templateUrl: 'folder-sick-notes-doctor-report-modal.component.html',
    styleUrls: ['folder-sick-notes-doctor-report-modal.component.scss'],
    imports: [
        DateInputComponent,
        TranslatePipe,
        CheckInputComponent,
        TextInputComponent,
        ActionButtonsComponent,
        DiagnosisSelectInputComponent,
        AddressInputComponent,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [FolderSickNotesDoctorReportModalStore],
})
export class FolderSickNotesDoctorReportModalComponent extends BaseDialogComponent {
    protected readonly store = inject(FolderSickNotesDoctorReportModalStore);

    protected form = fb.group({
        walkoutsChange: fb.control<boolean>(false),
        walkoutsFromDate: fb.control<Date | null>(null),
        walkoutsToDate: fb.control<Date | null>(null),
        walkoutsFrom1: fb.control<string | null>(null),
        walkoutsTo1: fb.control<string | null>(null),
        walkoutsFrom2: fb.control<string | null>(null),
        walkoutsTo2: fb.control<string | null>(null),
        walkoutsIndividual: fb.control<boolean>(false),

        walkoutsCancel: fb.control<boolean>(false),
        walkoutsCancelFromDate: fb.control<Date | null>(null),

        addressChange: fb.control<boolean>(false),
        addressChangeFromDate: fb.control<Date | null>(null),
        addressChangeToDate: fb.control<Date | null>(null),
        address: fb.control<AddressDetailObject | null>(null),
        addressAddition: fb.control<string | null>(null),

        diagnosisChange: fb.control<boolean>(false),
        diagnosisChangeDate: fb.control<Date | null>(null),
        diagnosisCode: fb.control<string | null>(null),

        regimeViolation: fb.control<boolean>(false),
        regimeViolationNote: fb.control<string | null>(null),

        handOver: fb.control<boolean>(false),
        handOverDate: fb.control<Date | null>(null),

        // TODO
        takeOver: fb.control<boolean>(false),
        takeOverDate: fb.control<Date | null>(null),
        takeOverIcpe: fb.control<string | null>(null),
        takeOverFromDoctor: fb.control<string | null>(null),
        takeOverCenterName: fb.control<string | null>(null),

        hospitalizationChange: fb.control<boolean>(false),
        hospitalizationChangeFromDate: fb.control<Date | null>(null),
        hospitalizationChangeToDate: fb.control<Date | null>(null),
    });

    protected prefix = 'sickNotes.doctorReport.form.';

    override save(): void | Promise<void> {
        if (this.form.isInvalid() && this.dialogConfig.data?.sickNoteId) return;

        const value = this.form.getRawValue();
        const holForm = {
            sickNoteId: +routeParams.sickNoteId(),
            ...this.form.getRawValue(),
            walkoutsFromDate: csszDateFormat(value.walkoutsFromDate),
            walkoutsToDate: csszDateFormat(value.walkoutsToDate),
            walkoutsFrom1: csszTimeFormat(value.walkoutsFrom1),
            walkoutsTo1: csszTimeFormat(value.walkoutsTo1),
            walkoutsFrom2: csszTimeFormat(value.walkoutsFrom2),
            walkoutsTo2: csszTimeFormat(value.walkoutsTo2),
            walkoutsCancelFromDate: csszDateFormat(
                value.walkoutsCancelFromDate,
            ),
            addressChangeFromDate: csszDateFormat(value.addressChangeFromDate),
            addressChangeToDate: csszDateFormat(value.addressChangeToDate),
            diagnosisChangeDate: csszDateFormat(value.diagnosisChangeDate),
            handOverDate: csszDateFormat(value.handOverDate),
            takeOverDate: csszDateFormat(value.takeOverDate),
            hospitalizationChangeFromDate: csszDateFormat(
                value.hospitalizationChangeFromDate,
            ),
            hospitalizationChangeToDate: csszDateFormat(
                value.hospitalizationChangeToDate,
            ),
        } as FolderSickNotesHolInput;

        this.store.api.updateHol(holForm).then((res) => {
            if (res.ok) {
                contentGlobalSuccess.next('common.created');
                this.dialogRef.close();
            }
        });
    }
}
